const onlyDigits = (value: string): string => value.replace(/\D+/g, '');

export const formatCpf = (cpf: string): string => {
  const d = onlyDigits(cpf);
  if (d.length !== 11) return cpf;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
};

export const formatCnpj = (cnpj: string): string => {
  const d = onlyDigits(cnpj);
  if (d.length !== 14) return cnpj;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
};

export const formatDocumento = (documento: string | null): string => {
  if (!documento) return '—';
  const d = onlyDigits(documento);
  if (d.length === 11) return formatCpf(documento);
  if (d.length === 14) return formatCnpj(documento);
  return documento;
};

export const formatTelefone = (telefone: string | null): string => {
  if (!telefone) return '—';
  const d = onlyDigits(telefone);
  // 11 digits (mobile with DDD): (11) 99999-9999
  if (d.length === 11) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  }
  // 10 digits (landline with DDD): (11) 9999-9999
  if (d.length === 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  // 13 digits (international 55 + DDD + 9): +55 (11) 99999-9999
  if (d.length === 13 && d.startsWith('55')) {
    return `+55 (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  }
  return telefone;
};

export const formatDateTime = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return iso;
  }
};

export const formatDate = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch {
    return iso;
  }
};

export const formatMoneyBRL = (value: number | null): string => {
  if (value == null) return '—';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};
